import { render, staticRenderFns } from "./Ports.vue?vue&type=template&id=72552746&"
import script from "./Ports.vue?vue&type=script&lang=ts&"
export * from "./Ports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports